import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import { IUserDetails } from "../exports/interfaces";
import UserList from "../components/user/UserList";
import { useLoader } from "../context/LoaderContext";
import { useUser } from "../context/UserContext";
import { fetchUsers } from "../api/UserApi";
import { dynamicFailed } from "../hooks/useToast";

const UserPage = () => {
  const { setLoading } = useLoader();
  const [users, setUsers] = useState<IUserDetails[]>([]);
  const [search, setSearch] = useState("");
  const { user } = useUser();

  useEffect(() => {
    if (!user) {
      return;
    }
    Promise.all([fetchUsers()])
      .then(([usersData]) => {
        setUsers(usersData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        dynamicFailed(`${error.message}`);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading, user]);
  return (
    <PageLayout>
      <SearchHeader />
      <div className="inner-main-content">
        <UserList
          user={users}
          setUser={setUsers}
          search={search}
          setSearch={setSearch}
        />
      </div>
    </PageLayout>
  );
};

export default UserPage;
